module.exports = __webpack_public_path__ + "img/Green.22dfd502.svg";